<h2 mat-dialog-title class="bg-primary !text-white">Add Attachment</h2>

<mat-dialog-content>
  <form [formGroup]="attachmentForm" class="flex flex-col gap-4">
    <mat-form-field appearance="fill">
      <mat-label>Attachment Name</mat-label>
      <input matInput formControlName="attachmentName" placeholder="Enter attachment name" />
    </mat-form-field>

    <div class="flex flex-row gap-2 items-end justify-between">
      <button
        mat-flat-button
        color="primary"
        type="button"
        (click)="triggerFileInput()"
        [disabled]="isUploading()"
      >
        <ng-container *ngIf="isUploading(); else browseText">
          <mat-spinner diameter="20" class="inline-block align-middle"></mat-spinner>
        </ng-container>
        <ng-template #browseText>BROWSE</ng-template>
      </button>
      <input type="file" class="hidden" id="fileInput" (change)="onFileSelected($event)" />
      <button
        mat-flat-button
        color="accent"
        type="button"
        (click)="viewAttachment()"
        [disabled]="isUploading() || !attachmentForm.get('attachmentDocument')?.value"
      >
        VIEW
      </button>
      <div *ngIf="uploadError()" class="text-red-600 text-xs mt-2 ml-1">{{ uploadError() }}</div>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button (click)="onCancel()">Cancel</button>
  <button mat-flat-button color="primary" (click)="onSubmit()" [disabled]="!attachmentForm.valid">
    Add Attachment
  </button>
</mat-dialog-actions>
